/**
 * Book offers progress bar in the Kalles mini cart drawer (snippets/book-offers.liquid).
 *
 * All offer logic runs in Liquid. Kalles re-renders [data-cart-items] from the mini_cart section on
 * every AJAX cart change and then dispatches `cart:update:count`; the fresh component is inside that
 * container as <template data-book-offers-source>, so this file only swaps it into the visible
 * component and animates the bar. Theme setting values reach CSS as custom properties on the
 * component root; the rules themselves live in assets/custom-design.css.
 */
(function () {
  'use strict';
  if (window.T4BookOffers) return;

  var ROOT = '[data-book-offers]';
  var DRAWER = '#t4s-mini_cart';
  var SOURCE = DRAWER + ' [data-cart-items] template[data-book-offers-source]';

  function setProgress(el, value) {
    el.style.setProperty('--book-offers-progress', (parseFloat(value) || 0) + '%');
  }

  function prepare(el) {
    var vars = {};
    try {
      vars = JSON.parse(el.getAttribute('data-bo-vars') || '{}');
    } catch (e) {}
    Object.keys(vars).forEach(function (name) {
      if (name.indexOf('--book-offers-') === 0 && typeof vars[name] === 'string' && vars[name] !== '') {
        el.style.setProperty(name, vars[name]);
      }
    });
    el.querySelectorAll('[data-bo-span]').forEach(function (item) {
      item.style.setProperty('--book-offers-span', (parseFloat(item.getAttribute('data-bo-span')) || 0) + '%');
    });
    el.setAttribute('data-bo-ready', '');
  }

  function initAll() {
    document.querySelectorAll(ROOT + ':not([data-bo-ready])').forEach(function (el) {
      prepare(el);
      setProgress(el, el.getAttribute('data-bo-progress'));
    });
  }

  function sync() {
    var current = document.querySelector(DRAWER + ' ' + ROOT);
    var source = document.querySelector(SOURCE);
    var fresh = source && source.content.querySelector(ROOT);
    if (!current || !fresh) return;

    fresh = fresh.cloneNode(true);
    var from = current.style.getPropertyValue('--book-offers-progress');
    current.replaceWith(fresh);
    prepare(fresh);

    // Start from the previous width so the change animates instead of jumping.
    setProgress(fresh, from);
    var fill = fresh.querySelector('.book-offers__fill');
    if (fill) void fill.offsetWidth;
    setProgress(fresh, fresh.getAttribute('data-bo-progress'));
  }

  // Kalles fires this after replacing the drawer contents on add, change, remove and cart:refresh.
  document.addEventListener('cart:update:count', sync);
  document.addEventListener('shopify:section:load', initAll);

  // Kalles fetches the mini_cart section after page load and appends it, so watch for new components.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      initAll();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.T4BookOffers = { sync: sync, init: initAll };
})();
